export const Rainbow = ['#ff2ecb', '#852efe', '#2ea8ff', '#2effaf', '#2eff54', '#eeff2e', '#ffb22e', '#ff742e', '#ff2e51' ,'#EA047E', '#FF6D28', '#FCE700', '#00F5FF', '#36AE7C', '#187498', '#A3DDCB', '#E8E9A1', '#E6B566', '#E5707E', '#FFD4D4', '#CDE990', '#AACB73', '#243763', '#AD8E70', '#064635', '#519259'];
export const Rainbow2 = ['#2eff54', '#eeff2e', '#ffb22e', '#ff742e', '#ff2e51', '#ff2ecb', '#852efe', '#2ea8ff', '#2effaf'];
export const Rainbow3 = ['#2ea8ff', '#2effaf', '#2eff54', '#eeff2e', '#ffb22e', '#ff742e', '#ff2e51', '#ff2ecb', '#852efe'];
export const FuelColor = {
	"BBG": '#2ea8ff',
	"BBG INDUSTRI": '#2effaf',
	"BIO SOLAR": "#a757c9",
	"BIOSOLAR INDUSTRI": "#ff2ecb",
	"DEXLITE": "#ff4ecb",
	"DEX LITE": "#ff4ecb",
	"PERTALITE": '#2eff54',
	"PERTALITE KHUSUS": '#ffb22e',
	"PERTAMAX": "#2e5bfe",
    "PERTAMAX GREEN" : "#2effaf",
	"PERTAMAX TURBO": "#ff2e51",
	"PERTAMAX RACING": "#ff742e",
	"PERTAMINA DEX": "#04c755",
	"PREMIUM": "#eeff2e",
	"VIGAS": "#eecc2e",
	"AVERAGE": "#006600",
	"LAST WEEK": "#e022a8",
	"TOTAL": "#888888",
	"ULLAGE": "#aaaaaa"
};

export const BankColor = {
  "BCA":    "#1A6ED8",  // Biru elegan khas BCA
  "BNI":    "#FF6B00",  // Oranye khas BNI
  "BRI":    "#780044",  // Biru tua khas BRI
  "Mandiri": "#00B0FF", // Kuning emas Mandiri
  "BSI":    "#00A884",  // Hijau toska BSI
  "BTN":    "#F9C846",  // Kuning terang (BTN)
  "DKI":    "#D60000",  // Merah terang DKI
  "MDR":    "#00B0FF",  // Biru muda modern (MDR bisa mewakili bank modern/Maybank)
  "BJB":    "#8f0fff",  // Hijau segar khas BJB
  "CIMB":   "#9E0B0F",  // Merah marun CIMB
  "Danamon": "#FF9F1C", // Oranye lembut Danamon
  "Permata": "#00A8A8", // Toska Permata Bank
};

export const BankColor2 = {
	"BCA": '#2e5bfe',
	"BNI": '#ff742e',
	"BRI": "#510fff",
	"BSI": "#04c755",
	"BTN": "#F4DC16",
	"DKI": "#FC1608",
	"MDR": '#2ea8ff',
	"Mandiri": '#2ea8ff',
	"BJB": "#ce0fff",
};

export const AppColors = ['#1F82E4','#F59B0E','#FC1608','#00B050','#852efe','#ff2ecb','#ffe30f','#5733FF','#ff660f','#00F5FF',
    '#510fff','#8f0fff','#ce0fff','#ff0ff1',
    '#ff0fb3','#ff0f74','#ff0f36',
    '#ff270f','#ff660f','#ffa40f','#ffe30f',
    '#ddff0f','#9eff0f','#5fff0f','#21ff0f',
    '#0fff3c','#0fff7a','#0fffb9','#0ffff8',
    '#0fc8ff','#0f89ff','#0f4aff','#120fff',
    '#510fff','#8f0fff','#ce0fff','#ff0ff1',
    '#ff0fb3','#ff0f74','#ff0f36',
    '#ff270f','#ff660f','#ffa40f','#ffe30f',
    '#ddff0f','#9eff0f','#5fff0f','#21ff0f',
    '#0fff3c','#0fff7a','#0fffb9','#0ffff8',
    '#0fc8ff','#0f89ff','#0f4aff','#120fff',
    '#510fff','#8f0fff','#ce0fff','#ff0ff1',
    '#ff0fb3','#ff0f74','#ff0f36'
];

export const AppColorsGradient = [
    '#ff270f','#ff660f','#ffa40f','#ffe30f',
    '#ddff0f','#9eff0f','#5fff0f','#21ff0f',
    '#0fff3c','#0fff7a','#0fffb9','#0ffff8',
    '#0fc8ff','#0f89ff','#0f4aff','#120fff',
    '#510fff','#8f0fff','#ce0fff','#ff0ff1',
    '#ff0fb3','#ff0f74','#ff0f36'

];

export const AppColorsGradient3 = [
    '#ff4538','#ff7938','#ffad38','#ffe138',
    '#e9ff38','#b5ff38','#82ff38','#4eff38',
    '#38ff56','#38ff8a','#38ffbe','#38fff2',
    '#38d8ff','#38a4ff','#3870ff','#383cff',
    '#6838ff','#9c38ff','#cf38ff','#ff38fb',
    '#ff38c7','#ff3893','#ff385f'
];

export const AppColorsGradient2 = [
    '#FFA133', '#FF5733', '#ff2e51', '#FF33A1', '#A133FF','#5733FF',
    '#3357FF', '#33A1FF', '#33FFF0', '#AAFF33', '#33FF57',
    '#57FF33', '#FF33C4', '#FF3366', '#FFAA33', '#E4FF33',

    '#A1FF33', '#3383FF', '#FF3383',
    '#33AAFF', '#FF33AA', '#AA33FF', '#33FFAA',
    '#33FF99', '#33CCFF', '#99FF33'
  ];


export const Config=()=>{

    // setting default HOST URL
    var webHOST,webPORT,apiHOST,apiPORT,webURL,apiURL,webSSO


    // Setting WebHOST Di local
    if(window.location.host.indexOf('localhost')>=0){
        webHOST=location.hostname
        webPORT=":"+window.location.port
        apiHOST="localhost"

        apiPORT=":8081"
        webURL="http://"+webHOST+webPORT
        apiURL="//"+apiHOST+apiPORT+"/api"

        //http://localhost/Dashboard_V3/FE/public/
        //apiPORT=":80"
        //apiURL="//"+apiHOST+apiPORT+"Dashboard_V3/FE/public/api"
    }

    //server dev
    else if(window.location.host.indexOf('ptprkpdev02') >=0) {
		webHOST=location.hostname
        webPORT=":8080" /// MASUKAN NO PORT WEB DI BELAKANG TITIK DUA (:)
        apiHOST=location.hostname
        apiPORT=":8081" /// MASUKAN NO PORT WEB DI BELAKANG TITIK DUA (:)

		//Ambil url
        //webHOST='localhost'
        webPORT=":8082"
		webURL="http://"+webHOST+webPORT
		apiURL="//"+apiHOST+apiPORT+"/api"
	}


    // Setting WebHOST Di Server Pertamina Retail
	// development
    else if(window.location.host.indexOf('10.245')>=0){
        webHOST=location.hostname
        webPORT=":8080" /// MASUKAN NO PORT WEB DI BELAKANG TITIK DUA (:)
        apiHOST=location.hostname
        apiPORT=":8081" /// MASUKAN NO PORT WEB DI BELAKANG TITIK DUA (:)

		//Ambil url
        //webHOST='localhost'
        webPORT=":8080"
		webURL="http://"+webHOST+webPORT
		apiURL="//"+apiHOST+apiPORT+"/api"

    }

	// production
    else if(window.location.host.indexOf('dashboard2')>=0){
		webURL="https://dashboard2.pertaminaretail.com/"
		apiURL="https://dashboard2-be.pertaminaretail.com/api"
	}
	// production
	else {
		webURL="https://dashboard.pertaminaretail.com/"
		apiURL="https://dashboard2-be.pertaminaretail.com/api"
	}

    webSSO='https://sso.pertaminaretail.com/Home/Login?app=Dashboard&returl='+webURL+'?'

    let options=
    {
        webURL, apiURL, webSSO
    }

    return options
}

export const Penanggalan= ()=>{

	var today = new Date()

	var sekarang = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate()
    var bulan = (today.getMonth() + 1)
	var yesterday = new Date(today.getTime() - ((1000*60*60*24) * 1))
	var kemarin = yesterday.getFullYear() + "-" + (yesterday.getMonth() + 1) + "-" + yesterday.getDate()

	var thisweek = new Date(today.getTime() - ((1000*60*60*24) * 7))
	var mingguSekarang = thisweek.getFullYear() + "-" + (thisweek.getMonth() + 1) + "-" + thisweek.getDate()

	var lastweek = new Date(today.getTime() - ((1000*60*60*24) * 14))
	var mingguKemarin = lastweek.getFullYear() + "-" + (lastweek.getMonth() + 1) + "-" + lastweek.getDate()

	var bulanSekarang = today.getFullYear() + "-" + (today.getMonth() + 1) + "-01"

	var lastmonth = new Date(today.getTime() - ((1000*60*60*24) * today.getDate()))
	var bulanKemarin = lastmonth.getFullYear() + "-" + (lastmonth.getMonth() + 1) + "-01"

	var tahunSekarang = today.getFullYear() + "-01-01"
	var tahun = today.getFullYear();

	let options=
	{
		tahun:tahun,
        bulan:bulan,
		sekarang:sekarang,
		kemarin:kemarin,
		mingguSekarang:mingguSekarang,
		mingguKemarin:mingguKemarin,
		bulanSekarang:bulanSekarang,
		bulanKemarin:bulanKemarin,
		tahunSekarang:tahunSekarang,
	}
	return options
}

export const chartLabel=(data)=>
{
    return data
}

import axios from 'axios'
import { wrapper } from 'axios-cookiejar-support';
import { CookieJar } from 'tough-cookie';
export const AxiosWithJar=()=>{
    const jar = new CookieJar();
    const axiosWithJar = wrapper(axios.create({ jar }));
    return axiosWithJar;
}

export const SVGiconBuilding=()=>{
    var string ='<svg width="12px" height="12px" viewBox="0 0 43 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">'+
    '<title>credit-card</title>'+
    '<g id="Basic-Elements" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">'+
      '<g id="Rounded-Icons" transform="translate(-2169.000000, -745.000000)" fill="#FFFFFF" fill-rule="nonzero">'+
        '<g id="Icons-with-opacity" transform="translate(1716.000000, 291.000000)">'+
          '<g id="credit-card" transform="translate(453.000000, 454.000000)">'+
            '<path class="color-background" d="M43,10.7482083 L43,3.58333333 C43,1.60354167 41.3964583,0 39.4166667,0 L3.58333333,0 C1.60354167,0 0,1.60354167 0,3.58333333 L0,10.7482083 L43,10.7482083 Z" id="Path" opacity="0.593633743"></path>'+
            '<path class="color-background" d="M0,16.125 L0,32.25 C0,34.2297917 1.60354167,35.8333333 3.58333333,35.8333333 L39.4166667,35.8333333 C41.3964583,35.8333333 43,34.2297917 43,32.25 L43,16.125 L0,16.125 Z M19.7083333,26.875 L7.16666667,26.875 L7.16666667,23.2916667 L19.7083333,23.2916667 L19.7083333,26.875 Z M35.8333333,26.875 L28.6666667,26.875 L28.6666667,23.2916667 L35.8333333,23.2916667 L35.8333333,26.875 Z" id="Shape"></path>'+
          '</g>'+
        '</g>'+
      '</g>'+
    '</g>'+
  '</svg>'
  return string
}

export const listMenuSidebar=()=>{

    const list=[
        //Overview
        {
            id:'overview',
            path:'/',
            name:'Overview',
            icon:'fab fa-chromecast',
			access:'MOD2020040002', // Operational Data
        },


        //Satgas
		{
            id:'satgas',
            path:'/satgas',
            name:'Satgas',
            icon:'fas fa-tachometer-alt',
			access:'MOD2022040002', // Satgas
            children:[
                {
                    id:'satgas-report',
                    path:'/satgas/report',
                    name:'Report',
                    icon:'',
                },
            ]
        },

        //Satgas Monitor
        {
            id:'satgas-monitor',
            path:'/satgas-monitor',
            name:'Monitor Satgas',
            icon:'fas fa-tachometer-alt',
			access:'MOD2022120002', // Satgas Untuk Vendor: MOD2022120002
        },

        //Satgas CNT
        /*
        {
            id:'satgas-cnt',
            path:'/satgas-cnt',
            name:'Satgas',
            icon:'fas fa-tachometer-alt',
			access:'MOD2022120003', // Satgas Untuk Pertamina Pusat C&T //MOD2022120003
            children:[
                {
                    id:'satgas-cnt-report',
                    path:'/satgas-cnt/report',
                    name:'Satgas Report',
                    icon:'',
                },
            ]
        },
        */

        //Fuel/SPBU
        {
            id:'fuel',
            path:'/fuel',
            name:'Fuel',
            icon:'fas fa-gas-pump',
			access:'MOD2020040002', // Operational Data
            children:[
                {
                    id:'fuel-coco',
                    path:'/fuel/coco',
                    name:'COCO',
                    icon:'',
                },
                {
                    id:'fuel-kso',
                    path:'/fuel/kso',
                    name:'KSO',
                    icon:'',
                },
                {
                    id:'fuel-tac',
                    path:'/fuel/tac',
                    name:'TAC',
                    icon:'',
                },
                /*
                {
                    id:'fuel-margin-tac',
                    path:'/fuel/margin-tac',
                    name:'Margin TAC',
                    icon:'',
                },
                */
                {
                    id:'fuel-outlet',
                    path:'/fuel/outlet',
                    name:'Station List',
                    icon:'',
                },
                {
                    id:'fuel-report2',
                    path:'/fuel/report2',
                    name:'Report',
                    icon:'',
                },
                /*
                {
                    id:'fuel-business-tracking',
                    path:'/fuel/fuel-tracking',
                    name:'Business Fuel Tracking',
                    icon:'',
                },
                */


                /*
                //Hide JBT
                {
                    id:'fuel-jbt',
                    path:'/fuel/jbt',
                    name:'JBT',
                    icon:'',
                },
                */


                /*
                {
                    id:'fuel-report2',
                    path:'/fuel/reportold',
                    name:'Report Old',
                    icon:'',
                },
                */

                {
                    id:'do-outstanding',
                    path:'/fuel/do-outstanding',
                    name:'DO Outstanding',
                    icon:'',
                    children:[
                        {
                            id:'do-outstanding-report',
                            path:'/fuel/do-outstanding/report',
                            name:'Report',
                            icon:'',
                        },
                    ],
                },

            ]
        },

        //SPBG (EMPTY)
        {
            id:'spbg',
            path:'/spbg',
            name:'SPBG',
            icon:'fab fa-gripfire',
			access:'MOD2024050004', // MOD2024050004
            children:[
                {
                    id:'spbg-report',
                    path:'/spbg/report',
                    name:'Report',
                    icon:'',
                },
            ]
        },

        //SPKLU (EMPTY)
        {
            id:'spklu',
            path:'/spklu',
            name:'SPKLU',
            icon:'fas fa-bolt',
			access:'MOD2024050006', // MOD2024050006
            children:[
                {
                    id:'spklu-report',
                    path:'/spklu/report',
                    name:'Report',
                    icon:'',
                },
            ]
        },


        //Bright Store
        {
            id:'bright',
            path:'/bright',
            name:'Bright Store',
            icon:'fas fa-store',
			access:'MOD2020060007', // Dashboard Bright
            children:[
                {
                    id:'bright-storelist',
                    path:'/bright/storelist',
                    name:'Store List',
                    icon:'',
                },
                {
                    id:'bright-top-store',
                    path:'/bright/store',
                    name:'Top Stores',
                    icon:'',
                },
                /*
                {
                    id:'bright-sales-waste',
                    path:'/bright/sales',
                    name:'Sales & Waste',
                    icon:'',
                },
                {
                    id:'bright-store-performance',
                    path:'/bright/performance',
                    name:'Store Performance',
                    icon:'',
                },
                {
                    id:'bright-stock',
                    path:'/bright/stock',
                    name:'Stock',
                    icon:'',
                },
				{
                    id:'bright-service-level',
					path:'/bright/sl',
					name:'Service Level',
                    icon:'',
				},
                */
                {
                    id:'bright-baseline-comparison',
					path:'/bright/baseline',
					name:'Baseline Comparison',
                    icon:'',
                    access:'MOD2023050007',
				},
                /*
                {
                    id:'bright-report',
                    path:'/bright/report',
                    name:'Report',
                    icon:'',
                },
                */
                {
                    id:'bright-report2',
                    path:'/bright/report2',
                    name:'Report',
                    icon:'',
                },

                //Dashboard Item //new menu
                {
                    id:'bright-dashboard-item',
                    path:'/bright/item',
                    name:'Dashboard Item ',
                    icon:'fas fa-file',
                    access:'MOD2023120002',
                },

                {
                    id:'bright-store-perfomance',
                    path:'/bright/store-performance',
                    name:'Performance ',
                    icon:'fas fa-file',
                    access:'MOD2023120002',
                },

                {
                    id:'bright-store-other-icome',
                    path:'/bright/other-income',
                    name:'Other Income ',
                    icon:'fas fa-file',
                    access:'MOD2023120002',
                },

                /*
                {
                    id:'bright-store-tracking',
                    path:'/bright/bright-store-tracking',
                    name:'Business Store Tracking',
                    icon:'',
                },
                */
            ]
        },

        //Bright Cafe
        {
            id:'cafe',
            path:'/cafe',
            name:'Bright Cafe',
            icon:'fas fa-store-alt',
			access:'MOD2020060007', // Dashboard Cafe
            children:[
                {
                    id:'cafe-list',
                    path:'/cafe/cafelist',
                    name:'Cafe List',
                    icon:'',
                },
                /*
                {
                    id:'cafe-sales-waste',
                    path:'/cafe/sales',
                    name:'Sales & Waste',
                    icon:'',
                },
                */
                {
                    id:'cafe-report',
                    path:'/cafe/report',
                    name:'Report',
                    icon:'',
                },
            ],
        },

        //Keagenan LPG
        {
            id:'lpg',
            path:'/lpg',
            name:'Keagenan LPG',
            icon:'fab fa-gripfire',
			access:'MOD2020040002', // Operational Data
            children:[
                {
                    id:'lpg-keagenan-list',
                    path:'/lpg/keagenan',
                    name:'Keagenan List',
                    icon:'',
                },
                {
                    id:'lpg-brimola-list',
                    path:'/lpg/KliringVAPangkalanLPG',
                    name:'Kliring VA Pangkalan LPG',
                    icon:'',
                },
                {
                    id:'lpg-report',
                    path:'/lpg/report',
                    name:'Report',
                    icon:'',
                },
                /*
                {
                    id:'lpg-report2',
                    path:'/lpg/reportold',
                    name:'Report Old',
                    icon:'',
                },
                */
            ]
        },

        //B2B (EMPTY)
        {
            id:'b2b',
            path:'/b2b',
            name:'B2B',
            icon:'fas fa-building',
			access:'MOD2024050005', // MOD2024050005
            children:[
                {
                    id:'b2b-report',
                    path:'/b2b/report',
                    name:'Report',
                    icon:'',
                },
            ]
        },

        //Merchandise
        {
            id:'merchandise',
            path:'/merchandise',
            name:'Merchandise Official',
            icon:'fas fa-store',
			access:'MOD2023100006', // mod merchandise: MOD2023100006
            children:[
                {
                    id:'merchandise-report',
                    path:'/merchandise/report',
                    name:'Report',
                    icon:'',
                },
            ]

        },

        //AutoCare/BOM (EMPTY)
        /*
        {
            id:'autocare',
            path:'/autocare',
            name:'Auto Care/BOM',
            icon:'fas fa-ambulance',
			access:'MOD2024050009', // MOD2024050009
            children:[
                {
                    id:'autocare-report',
                    path:'/autocare/report',
                    name:'Report',
                    icon:'',
                },
            ]
        },
        */

        //Property Management
        {
            id:'PropertyManagement',
            path:'/property-management',
            name:'Property Management',
            icon:'fas fa-cubes',
			access:'MOD2024050008', // // MOD2024050008
            children:[
                {
                    id:'property-management-report',
                    path:'/property-management/report',
                    name:'Report',
                    icon:'',
                },

            ]
        },

        //BPP/PPOB (EMPTY)
        {
            id:'ppob',
            path:'/ppob',
            name:'Bright Payment Point',
            icon:'fas fa-credit-card',
			access:'MOD2024050007', // MOD2024050007
            children:[
                {
                    id:'ppob-report',
                    path:'/ppob/report',
                    name:'Report',
                    icon:'',
                },
            ]
        },

        //Bisniss Unit
        {
            id:'business-unit',
            path:'/business-unit',
            name:'Business Unit',
            icon:'fab fa-chromecast',
			access:'MOD2024070014', // Sample: MOD2020040002, MOD Unit Business: MOD2024070014
            /*
            children:[
                {
                    id:'business-unit-detail',
                    path:'/business-unit/detail',
                    name:'Business Unit Detail',
                    icon:'',
                },
            ]
            */
        },

        //Customer #Added to Finance Group
        {
            id:'customer',
            path:'/customer',
            name:'Customer',
            icon:'fas fa-ticket-alt',
			access:'MOD2024070013', // Sample: MOD2020040002, MOD Customer: MOD2024070013
            children:[
                {
                    id:'customer-complaint',
                    path:'/customer/complaint',
                    name:'Complaint',
                    icon:'',
                },
                {
                    id:'customer-sinergi',
                    path:'/customer/sinergi',
                    name:'Sinergi PTPR',
                    icon:'',
                },



                {
                    id:'customer-report',
                    path:'/customer/report',
                    name:'Report',
                    icon:'',
                },
                /*
                {
                    id:'customer-complaint2',
                    path:'/customer/complaintold',
                    name:'Complaint Old',
                    icon:'',
                }, */
                 /*
                {
                    id:'customer-report2',
                    path:'/customer/reportold',
                    name:'Report Old',
                    icon:'',
                }, */
            ]
        },

        //Supply Chain
        {
            id:'supply-chain',
            path:'/supply-chain',
            name:'Supply Chain',
            icon:'fas fa-boxes',
			access:'MOD2023110056', // Supply Chain
            children:[
                {
                    id:'supply-chain-report',
                    path:'/supply-chain/report',
                    name:'Report',
                    icon:'',
                },
                /*
                //Moved to Report Above
                {
                    id:'supply-chain-report-item-quota',
                    path:'/supply-chain/item-quota',
                    name:'Report Item Quota',
                    access:'MOD2023070008',
                    icon:'',
                },
                */
            ],
        },

        //Business Tracking
        {
            id:'business-tracking',
            path:'/business-tracking',
            name:'Business Tracking',
            icon:'fas fa-chart-line',
			access:'MOD2024070009', ////sample:MOD2020040002, business tracking mod: MOD2024070009
            children:[
                {
                    id:'business-tracking-fuel',
                    path:'/business-tracking/fuel',
                    name:'Fuel Tracking',
                    icon:'',
                },
                {
                    id:'business-tracking-bright-store',
                    path:'/business-tracking/bright-store',
                    name:'Bright Store Tracking',
                    icon:'',
                },
                {
                    id:'business-tracking-fuel-sales',
                    path:'/business-tracking/sales-tracking',
                    name:'Sales Tracking',
                    icon:'',
                    children:[
                        {
                            id:'business-tracking-fuel-sales-value',
                            path:'/business-tracking/sales-tracking/value',
                            name:'Sales Value',
                            icon:'',
                        },
                        {
                            id:'business-tracking-fuel-sales-volume',
                            path:'/business-tracking/sales-tracking/volume',
                            name:'Sales Volume',
                            icon:'',
                        },
                        {
                            id:'business-tracking-fuel-sales-spd',
                            path:'/business-tracking/sales-tracking/spd',
                            name:'SPD',
                            icon:'',
                        },
                    ]
                },
            ]
        },

        //POST MORTEM
        /*
        {
            id:'post-mortem',
            path:'/post-mortem',
            name:'Post Mortem',
            icon:'fas fa-th-list',
			access:'MOD2024070012', //sample:MOD2020040002 , POST Mortem: MOD2024070012
            children:[

                {
                    id:'post-mortem-overview',
                    path:'/post-mortem/overview',
                    name:'Overview',
                    icon:'',
                },
                {
                    id:'post-mortem-waterfall',
                    path:'/post-mortem/waterfall',
                    name:'Waterfall',
                    icon:'',
                },
                {
                    id:'post-mortem-performance',
                    path:'/post-mortem/performance',
                    name:'Performance',
                    icon:'',
                },


                //{
                //    id:'post-mortem-report',
                //    path:'/post-mortem/report',
                //    name:'Report',
                //    icon:'',
                //},

            ]
        },
        */

        //HSSE
        {
            id:'hsse',
            path:'/hsse',
            name:'HSSE',
            icon:'fas fa-hard-hat',
			access:'MOD2020040002', // Operational Data
            children:[
                {
                    id:'hsse-action-tracking',
                    path:'/hsse/action-tracking',
                    name:'Action Tracking',
                    icon:'',
                },
            ]
        },

        //HRGA
        {
            id:'hrga',
            path:'/hrga',
            name:'HRGA',
            icon:'fas fa-users',
			access:'MOD2023100007', // mod hrga: MOD2023100007
            children:[
                {
                    id:'hrga-report',
                    path:'/hrga/report',
                    name:'Report',
                    icon:'',
                },
            ]

        },

        //Maintetance
        {
            id:'maintenance',
            path:'/maintenance',
            name:'Maintenance',
            icon:'fas fa-cogs',
			access:'MOD2020040002', // Maintenance Report
            children:[
                {
                    id:'maintenance-report-posting-bos',
                    path:'/maintenance/posting-bos',
                    name:'Posting BOS',
                    icon:'',
                    children:[
                        {
                            id:'maintenance-report-posting-bos-report',
                            path:'/maintenance/posting-bos/report',
                            name:'Report Posting BOS',
                            icon:'',
                        },
                    ]
                },
                {
                    id:'maintenance-report',
                    path:'/maintenance/report',
                    name:'Report',
                    icon:'',
                },
                /*
                {
                    id:'maintenance-operation',
                    path:'/maintenance/operation',
                    name:'Operation',
                    icon:'',
                }, */
            ]
        },

        //Maintenance Monitor
        {
            id:'maintenance-monitor',
            path:'/maintenance-monitor',
            name:'Maintenance',
            icon:'fas fa-cogs',
			access:'MOD2022120002', //MOD2022120002 Maintenance vendor
        },

        //Vendor #Moved to Finance Group
        /*
        {
            id:'vendor',
            path:'/vendor',
            name:'Vendor',
            icon:'fas fa-warehouse',
			access:'MOD2020090001', // Dashboard Pengadaan
            children:[
                {
                    id:'vendor-report',
                    path:'/vendor/report',
                    name:'Report',
                    icon:'',
                },
            ]
        },
        */
		/*
        {
            id:'finance',
            path:'/finance',
            name:'Financial Report',
            icon:'fas fa-coins',
			access:'MOD2020070004', // Dashboard FBS
        },
		*/
        /*
        //original source
        {
            id:'finance-report',
            path:'/financereport',
            name:'Financial Report',
            icon:'fas fa-coins',
			access:'MOD2020070004',
            children: [
                {
                    id:'finance-report-treasury',
                    path:'/financereport/treasury',
                    name:'Treasury',
                    icon:'',
                    //access:'MOD2023010012', // Dashboard FBS //MOD2023010012
                },

            ]
        }, */

        //Finance Report #Moved to Finance Group
        /*
        {
            id:'finance-report',
            path:'/financereport',
            name:'Financial Report',
            icon:'fas fa-coins',
			access:'MOD2020040002', // Operational Data
        },
        */

        //Treasury #Moved to Finance Group
        /*
        {
            id:'treasury',
            path:'/treasury',
            name:'Treasury',
            icon:'fas fa-coins',
            access:'MOD2023010012', // Dashboard FBS // //MOD2020040002
            children:[
                {
                    id:'treasury-income',
                    path:'/treasury/income',
                    name:'Penerimaan',
                    icon:'',
                },
                {
                    id:'treasury-outcome',
                    path:'/treasury/outcome',
                    name:'Pengeluaran',
                    icon:'',
                },
            ]
        },
        */

        //Kinerja Keuangan #Move to Finance Group
        /*
        {
            id:'performance-report',
            path:'/performance-report',
            name:'Kinerja Keuangan',
            icon:'fas fa-coins',
            access:'MOD2023070009',//Kinerja: MOD2023070009 // Dashboard FBS // //MOD2020040002
            children:[
                {
                    id:'performance-report-present',
                    path:'/performance-report/intro',
                    name:'Present',
                    icon:'',
                },
                {
                    id:'performance-report-outlet',
                    path:'/performance-report/fuel-retail',
                    name:'Pertumbuhan Outlet',
                    icon:'',
                },

                {
                    id:'performance-report-volume-losses',
                    path:'/performance-report/sales-losses',
                    name:'Sales Volume & Losses',
                    icon:'',
                },
                {
                    id:'performance-report-profit-loss',
                    path:'/performance-report/profit-laba',
                    name:'Profit & Loss',
                    icon:'',
                },
                */

                /*
                {
                    id:'performance-report-non-fuel-retail',
                    path:'/performance-report/non-fuel-retail',
                    name:'Pertumbuhan Non Fuel Retail',
                    icon:'',
                },

                {
                    id:'performance-report-sales-volume',
                    path:'/performance-report/sales-volume',
                    name:'Sales Volume',
                    icon:'',
                },
                {
                    id:'performance-report-losses-by-product',
                    path:'/performance-report/losses-by-product',
                    name:'Losses By Product',
                    icon:'',
                },
                {
                    id:'performance-report-konsolidasi',
                    path:'/performance-report/konsolidasi',
                    name:'Konsolidasi',
                    icon:'',
                },
                */
               /*
                {
                    id:'performance-report-revenue-laba',
                    path:'/performance-report/revenue-and-laba',
                    name:'Revenue & Laba',
                    icon:'',
                },
                */
                /*
                {
                    id:'performance-report-financial-fuel-business',
                    path:'/performance-report/financial-fuel-business',
                    name:'Financial Fuel Business',
                    icon:'',
                },
                {
                    id:'performance-report-financial-non-fuel-business',
                    path:'/performance-report/financial-non-fuel-business',
                    name:'Financial Non Fuel',
                    icon:'',
                },
                */
               /*
                {
                    id:'performance-report-tingkat-kesehatan',
                    path:'/performance-report/tingkat-kesehatan',
                    name:'Tingkat Kesehatan',
                    icon:'',
                },
                {
                    id:'performance-report-rasio-keuangan',
                    path:'/performance-report/rasio-keuangan',
                    name:'Rasio Keuangan',
                    icon:'',
                },
                {
                    id:'performance-report-realiasi-abo',
                    path:'/performance-report/realisasi-abo',
                    name:'Realisasi ABO',
                    icon:'',
                },
                {
                    id:'performance-report-realisasi-capex',
                    path:'/performance-report/realisasi-capex',
                    name:'Realisasi CAPEX',
                    icon:'',
                },
                {
                    id:'performance-report-end-present',
                    path:'/performance-report/end-present',
                    name:'Thanks',
                    icon:'',
                },
            ]
        },
        */

        //Finance Group
        {
            id:'finance-group',
            path:'/finance',
            name:'Finance',
            icon:'fas fa-coins',
			access:'MOD2023110064', // Finance Group: MOD2023110064, sample: MOD2023070009
            children:[
                //Moved to Main Menu Customer
                /*
                {
                    id:'finance-group-customer',
                    path:'/customer',
                    name:'Customer',
                    icon:'fas fa-ticket-alt',
                    access:'MOD2020040002', // Operational Data
                    children:[
                        {
                            id:'finance-group-customer-complaint',
                            path:'/customer/complaint',
                            name:'Complaint',
                            icon:'',
                        },
                        {
                            id:'finance-group-customer-sinergi',
                            path:'/customer/sinergi',
                            name:'Sinergi PTPR',
                            icon:'',
                        },
                        */
                        /*
                        {
                            id:'finance-group-customer-report',
                            path:'/customer/report',
                            name:'Report',
                            icon:'',
                        },
                        {
                            id:'finance-group-customer-complaint2',
                            path:'/customer/complaintold',
                            name:'Complaint Old',
                            icon:'',
                        },
                        {
                            id:'finance-group-customer-report2',
                            path:'/customer/reportold',
                            name:'Report Old',
                            icon:'',
                        },
                        */
                    /*
                    ]
                },
                */

                //Top 10 Piutang
                {
                    id:'finance-group-piutang',
                    path:'/piutang',
                    name:'Top 10 Piutang',
                    icon:'fas fa-warehouse',
                    access:'MOD2020090001', // Dashboard Pengadaan
                    /*
                    children:[
                        {
                            id:'finance-group-vendor-report',
                            path:'/vendor/report',
                            name:'Report',
                            icon:'',
                        },
                    ]
                    */
                },

                //Vendor, Change name to Top 10 Hutang
                {
                    id:'finance-group-vendor',
                    path:'/vendor',
                    name:'Top 10 Hutang',
                    icon:'fas fa-warehouse',
                    access:'MOD2020090001', // Dashboard Pengadaan
                    /*
                    children:[
                        {
                            id:'finance-group-vendor-report',
                            path:'/vendor/report',
                            name:'Report',
                            icon:'',
                        },
                    ]
                    */
                },

                //Petty Cash
                {
                    id:'finance-group-pettycash',
                    path:'/finance/pettycash',
                    name:'Petty Cash',
                    icon:'fas fa-coins',
                    access:'MOD2023010012', // Dashboard FBS // //MOD2020040002
                    children:[
                        {
                            id:'finance-group-pettycash-report',
                            path:'/finance/pettycash/report',
                            name:'Petty Cash Report',
                            icon:'',
                        },
                    ]
                },

                //Finance Report
                /*
                {
                    id:'finance-group-finance-report',
                    path:'/financereport',
                    name:'Financial Report',
                    icon:'fas fa-coins',
                    access:'MOD2020040002', // Operational Data
                },
                */

                /*
                //Treasury
                {
                    id:'finance-group-treasury',
                    path:'/treasury',
                    name:'Treasury',
                    icon:'fas fa-coins',
                    access:'MOD2023010012', // Dashboard FBS // //MOD2020040002
                    children:[
                        {
                            id:'finance-group-treasury-income',
                            path:'/treasury/income',
                            name:'Penerimaan',
                            icon:'',
                        },
                        {
                            id:'finance-group-treasury-outcome',
                            path:'/treasury/outcome',
                            name:'Pengeluaran',
                            icon:'',
                        },
                    ]
                },
                */

                //Treasury New

                {
                    id:'finance-group-treasury-overview',
                    path:'/treasury-overview',
                    name:'Treasury Overview',
                    icon:'fas fa-coins',
                    access:'MOD2023010012', // Dashboard FBS // //MOD2020040002
                    children:[
                        {
                            id:'finance-group-treasury-cash-flow',
                            path:'/treasury/cash-flow',
                            name:'Cash Flow',
                            icon:'',
                        },
                        {
                            id:'finance-group-treasury-daily-balance',
                            path:'/treasury/daily-balance',
                            name:'Saldo Harian',
                            icon:'',
                        },
                    ]
                },


                //Kinerja Keuangan
                {
                    id:'finance-group-performance-report',
                    path:'/performance-report',
                    name:'Kinerja Keuangan',
                    icon:'fas fa-coins',
                    access:'MOD2023070009',//Kinerja: MOD2023070009 // Dashboard FBS // //MOD2020040002
                    children:[
                        {
                            id:'finance-group-performance-report-present',
                            path:'/performance-report/intro',
                            name:'Present',
                            icon:'',
                        },
                        {
                            id:'finance-group-performance-report-outlet',
                            path:'/performance-report/fuel-retail',
                            name:'Pertumbuhan Outlet',
                            icon:'',
                        },

                        {
                            id:'finance-group-performance-report-volume-losses',
                            path:'/performance-report/sales-losses',
                            name:'Sales & Losses', //Sales Volume & Losses
                            icon:'',
                        },
                        {
                            id:'finance-group-performance-report-profit-loss',
                            path:'/performance-report/profit-laba',
                            name:'Profit & Loss',
                            icon:'',
                        },

                        {
                            id:'finance-group-performance-report-revenue-laba',
                            path:'/performance-report/revenue-and-laba',
                            name:'Revenue & Laba',
                            icon:'',
                        },

                        {
                            id:'finance-group-performance-report-tingkat-kesehatan',
                            path:'/performance-report/tingkat-kesehatan',
                            name:'Tingkat Kesehatan',
                            icon:'',
                        },
                        {
                            id:'finance-group-performance-report-rasio-keuangan',
                            path:'/performance-report/rasio-keuangan',
                            name:'Rasio Keuangan',
                            icon:'',
                        },
                        {
                            id:'finance-group-performance-report-realiasi-abo',
                            path:'/performance-report/realisasi-abo',
                            name:'Realisasi ABO',
                            icon:'',
                        },
                        {
                            id:'finance-group-performance-report-realisasi-capex',
                            path:'/performance-report/realisasi-capex',
                            name:'Realisasi CAPEX',
                            icon:'',
                        },
                        {
                            id:'finance-group-performance-report-end-present',
                            path:'/performance-report/end-present',
                            name:'Thanks',
                            icon:'',
                        },
                    ]
                },

                {
                    id:'finance-group-pl-unit-laporan-manajemen',
                    path:'/finance/pl-unit/laporan-manajemen',
                    name:'Laporan Manajemen',
                    children:[
                        {
                            id:'finance-group-pl-unit-volume-real-vs-rkap',
                            path:'/finance/pl-unit/volume-real-vs-rkap',
                            name:'Volume Realisasi VS RKAP',
                            icon:'',
                        },
                    ],
                },

                {
                    id:'finance-group-pl-unit',
                    path:'/finance/pl-unit',
                    name:'PL Unit',
                    icon:'fas fa-file',
                    access:'MOD2023070009', // PL Unit //MOD2023070009
                    children:[

                        /*
                        {
                            id:'finance-group-pl-unit-volume-real-vs-rkap',
                            path:'/finance/pl-unit/volume-real-vs-rkap',
                            name:'Volume Real VS RKAP',
                            icon:'',
                        },
                        */

                        {
                            id:'finance-group-pl-unit-report',
                            path:'/finance/pl-unit/report',
                            name:'Report',
                            icon:'',
                        },
                    ],
                },

                //Finance Group report
                {
                    id:'finance-group-report',
                    path:'/finance/report-group',
                    name:'Report',
                    icon:'fas fa-file',
                    //access:'MOD2023010012', // Dashboard FBS // //MOD2020040002
                },

                //Monitoring COGS //new menu
                {
                    id:'finance-group-monitoring-cogs',
                    path:'/finance/monitoring-cogs',
                    name:'Monitoring COGS',
                    icon:'fas fa-file',
                    access:'MOD2023120003',
                },

                {
                    id:'finance-group-cash-deposit',
                    path:'/finance/cash-deposit',
                    name:'Cash Deposit',
                    icon:'fas fa-file',
                    //access:'MOD2023010012', // Dashboard FBS // //MOD2020040002
                    children:[
                        {
                            id:'finance-group-cash-deposit-report',
                            path:'/finance/cash-deposit/report',
                            name:'Report',
                            icon:'',
                        },
                        /*
                        {
                            id:'finance-group-cash-deposit-today-summary',
                            path:'/finance/cash-deposit/today-summary',
                            name:'Today Summary',
                            icon:'',
                        },
                        {
                            id:'finance-group-cash-deposit-day-end',
                            path:'/finance/cash-deposit/day-end',
                            name:'Day End',
                            icon:'',
                        },
                        {
                            id:'finance-group-cash-deposit-bag-replacement',
                            path:'/finance/cash-deposit/bag-replacement',
                            name:'Bag Replacement',
                            icon:'',
                        },
                        {
                            id:'finance-group-cash-deposit-denom-summary',
                            path:'/finance/cash-deposit/denom-summary',
                            name:'Denom Summary',
                            icon:'',
                        },
                        */
                    ]
                },
            ]
        },

        //ONLY FOR CNT MENU
        //Overview CNT
        {
            id:'overview-cnt',
            path:'/overview-cnt',
            name:'Overview',
            icon:'fab fa-chromecast',
			access:'MOD2023120009', // CNT MOD2023120009
        },

        //Store (Bright) CNT
        {
            id:'bright-cnt',
            path:'/bright-cnt',
            name:'Store',
            icon:'fas fa-store',
			access:'MOD2023120009', // Dashboard CNT MOD2023120009
            children:[
                {
                    id:'bright-storelist-cnt',
                    path:'/bright/storelist-cnt',
                    name:'Store List',
                    icon:'',
                },
                {
                    id:'bright-top-store-cnt',
                    path:'/bright/store-cnt',
                    name:'Top Stores',
                    icon:'',
                },

                {
                    id:'bright-baseline-comparison-cnt',
					path:'/bright/baseline-cnt',
					name:'Baseline Comparison',
                    icon:'',
                    //access:'MOD2023050007',
				},
                {
                    id:'bright-report-cnt',
                    path:'/bright/report-cnt',
                    name:'Report',
                    icon:'',
                },
            ]
        },
        //END FOR CNT MENU

        //NFR
        /*
        {
            id:'nfr',
            path:'/nfr',
            name:'NFR',
            icon:'fab fa-chromecast',
            access:'MOD2020040002', // Operational Data
        },
        */

        //Mandalika GP
        {
            id:'gp-mandalika',
            path:'/gp-mandalika',
            name:'Mandalika GP',
            icon:'fa fa-motorcycle',
			access:'MOD2024090034', // Operational Data:MOD2020040002 //GP: MOD2024090034
        },

        /*
        {
            id:'overview-monitor',
            path:'/monitor/overview',
            name:'Overview Monitor',
            icon:'fa fa-chromecast',
			access:'',
            children:[
                {
                    id:'overview-monitor-sales-achievement',
                    path:'/monitor/overview/sales-achievement',
                    name:'Sales Achievement',
                    icon:'',
                },
                {
                    id:'overview-monitor-sales-tracking',
                    path:'monitor/overview/sales-tracking',
                    name:'Sales Tracking',
                    icon:'',
                },
                {
                    id:'overview-monitor-fuel',
                    path:'monitor/overview/fuel',
                    name:'Fuel',
                    icon:'',
                },
            ],
        },
        */

    ]

    return list

}
export default
{
    Penanggalan,
    Config,
    chartLabel,
    AxiosWithJar,
    SVGiconBuilding,
    listMenuSidebar,
}
